import { element } from './element';

type ElementType = HTMLElement;

export function emojiIcon(emoji: string): ElementType {
  return element('i', 'bi emoji-icon', { textContent: emoji });
}
